import React, { useState, useContext, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { GoogleMap, Circle, Marker } from '@react-google-maps/api';
import ActiveMarker from '../../assets/active-marker.svg';
import { lightMapTheme } from '../../services';
import { StoreContext } from '../../store';
import useGoogleMaps from '../../useGoogleMaps';

const MAP_OPTIONS = {
  zoomControl: false,
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  styles: lightMapTheme,
  keyboardShortcuts: false,
};

const QuizLocations = ({ locations, handleExit }) => {
  const { dispatch, actions } = useContext(StoreContext);
  const navigate = useNavigate();

  const [mapCenter] = useState({
    lat: parseFloat(locations[0]?.lat),
    lng: parseFloat(locations[0]?.lng),
  });

  const isLoaded = useGoogleMaps();

  const markerIcon = useMemo(() => {
    if (!isLoaded) return null;
    const size = locations.length > 10 ? [20, 25] : [30, 35];
    return {
      url: ActiveMarker,
      scaledSize: new window.google.maps.Size(size[0], size[1]),
    };
  }, [isLoaded, locations.length]);

  const onLoad = useCallback((map) => {
    map.setMapTypeId('roadmap');
  }, []);

  const handleAddressClick = useCallback(async (object) => {
    dispatch({ type: 'SET_SHOW_DASHBOARD', payload: false });
    dispatch({ type: 'SET_SHOW_SEARCH_ADDRESS', payload: false });
    await actions.fetchAddressData(object.address);
    navigate('/');
  }, [dispatch, actions, navigate]);

  return (
    <div className="quiz-locations-container">
      <div className="address-result">
        <p className="address-result-title">Top Address Matches</p>
        {locations.map((item, index) => (
          <div
            key={`address-${index}`}
            className="address-item"
            onClick={() => handleAddressClick(item)}
          >
            <div className='max-w-[230px]'>{item?.address}</div>
            <div className='text-[#fe572a]'>
              <div className='text-lg font-medium'>{item?.match_score}%</div>
              <div className='text-xs'>matched</div>
            </div>
          </div>
        ))}
      </div>
      <div className="address-result-map">
        {isLoaded && (
          <GoogleMap
            mapContainerStyle={{ height: '100%', width: '100%' }}
            center={mapCenter}
            zoom={14}
            onLoad={onLoad}
            options={MAP_OPTIONS}
          >
            {locations.map((marker, index) => (
              <React.Fragment key={`loc-${index}`}>
                <Circle
                  center={{
                    lat: parseFloat(marker?.lat),
                    lng: parseFloat(marker?.lng),
                  }}
                  radius={402.34}
                  options={{
                    strokeColor: '#1EF04C',
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    fillColor: 'transparent',
                  }}
                />
                <Marker
                  position={{
                    lat: parseFloat(marker?.lat),
                    lng: parseFloat(marker?.lng),
                  }}
                  icon={markerIcon}
                />
              </React.Fragment>
            ))}
          </GoogleMap>
        )}
        <button className='exit-map' onClick={handleExit}>
          Exit Map
        </button>
      </div>
    </div>
  );
};

export default QuizLocations;
